import axiosClient from 'config/axiosClient';

const _url = '/Api/Ticket';

const ticketService = {
    create: (option: any) => {
        return axiosClient.post(_url + '/Create', option);
    },
    update: (option: any) => {
        return axiosClient.post(_url + '/Update', option);
    },
    delete: (id: string) => {
        return axiosClient.post(_url + '/Delete', { id: id });
    },
    useTicket: (option: any) => {
        return axiosClient.post(_url + '/Use', option);
    },
    cancelTicket: (option: any) => {
        return axiosClient.post(_url + '/Cancel', option);
    },
    get: (id: string) => {
        return axiosClient.post(_url + '/Get', { id: id });
    },
    getPaging: (option: any) => {
        return axiosClient.post(_url + '/GetPaging', option);
    },
    checkTicket: (option: any) => {
        return axiosClient.post(_url + '/Check', option);
    },
    getRevenue: (option: any) => {
        return axiosClient.post(_url + '/GetRevenueStatistics', option);
    },
    getTransactions: (option: any) => {
        return axiosClient.post(_url + '/GetTransactionHistory', option);
    }
};

export default ticketService;